'use strict';

// var Constants = require('../constants/constants');
var SidebarCollapse = require('../sidebar-collapse/sidebar-collapse');

// Constructor
var PubSearch = function() {

  var self = this;

  self.config = {
    'button'     :  $('.form__button-show'),
    'content'    :  $('.form__content'),
    'eventName'  :  'form'
  }

  self.init = function() {
    new SidebarCollapse(self.config).init();
  }
};

module.exports = PubSearch;
